import { type RefObject } from 'react';
import { useDocumentVisible } from './useDocumentVisible';
import { useInViewport } from './useInViewport';

/** Viewport + tab visibility for preview-board mount and autoplay gating. */
export const usePreviewBoardVisibility = (ref: RefObject<Element | null>) => {
  const inViewport = useInViewport(ref);
  const inViewportLive = useInViewport(ref, { once: false });
  const documentVisible = useDocumentVisible();
  const animationsActive = inViewportLive && documentVisible;

  return { inViewport, animationsActive };
};
